import Input from '@/components/ui/Input/Input'
import type { ChangeEvent, KeyboardEvent } from 'react'
import styles from './registration.module.css'

import { Button } from '@/components/ui/Button'
import type { RegistrationData } from '@/types'

interface RegistrationFormProps {
  values: RegistrationData
  // errors: RegistrationErrors
  // generalError?: string
  isSubmitting: boolean
  acceptedTerms: boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onSubmit: () => void
  onBack: () => void
  onSignIn: () => void
  onToggleAcceptTerms: (checked: boolean) => void
}

const RegistrationForm = ({
  values,
  // errors,
  // generalError,
  isSubmitting,
  acceptedTerms,
  onChange,
  onSubmit,
  onBack,
  onToggleAcceptTerms,
}: RegistrationFormProps) => {
  const handleKeyDown = (event: KeyboardEvent, handler: () => void) => {
    if (event.key === 'Enter' || event.key === ' ') handler()
  }

  const areFieldsEmpty = !values.email || !values.password || !values.confirmPassword
  const nextDisabled = isSubmitting || !acceptedTerms || areFieldsEmpty

  return (
    <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
      <Input id="email" placeholder="Email" value={values.email} onChange={onChange} disabled={isSubmitting} />

      <Input id="password" type="password" placeholder="Password" value={values.password} onChange={onChange} disabled={isSubmitting} />

      <Input
        id="confirmPassword"
        type="password"
        placeholder="Confirm Password"
        value={values.confirmPassword}
        onChange={onChange}
        disabled={isSubmitting}
        // error={errors.confirmPassword}
      />

      <label htmlFor="acceptTerms" className={styles.checkbox}>
        <input
          id="acceptTerms"
          type="checkbox"
          className={styles.checkboxInput}
          checked={acceptedTerms}
          onChange={(e) => onToggleAcceptTerms(e.target.checked)}
          disabled={isSubmitting}
        />
        <span aria-hidden="true" className={styles.checkboxBox} />
        <span className={styles.tc} style={{ margin: 0 }}>
          I accept the{' '}
          <a href="/terms" target="_blank" rel="noreferrer" className={styles.link}>
            Terms
          </a>{' '}
          &{' '}
          <a href="/conditions" target="_blank" rel="noreferrer" className={styles.link}>
            Conditions
          </a>
        </span>
      </label>

      <div className={styles.buttonGroup}>
        <Button
          type="button"
          variant="outline"
          size="large"
          style={{ width: '100%' }}
          className={styles.backBtn}
          onClick={onBack}
          onKeyDown={(e) => handleKeyDown(e, onBack)}
        >
          Back
        </Button>
        <Button
          type="button"
          variant="fill"
          size="large"
          style={{ width: '100%' }}
          className={`${styles.submitBtn} ${nextDisabled ? styles.submitBtnDisabled : ''}`}
          onClick={onSubmit}
          onKeyDown={(e) => handleKeyDown(e, onSubmit)}
          disabled={nextDisabled}
        >
          Next
        </Button>
      </div>
    </form>
  )
}

export default RegistrationForm
